<template>
  <nav class="navbar">
    <div class="navbar-container">
      <!-- Left: Mobile burger + Logo -->
      <button class="burger" @click="$emit('toggle-sidebar')" aria-label="Open menu">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </button>
      <router-link to="/">
        <img class="logo" src="@/assets/img/logo.webp" />
      </router-link>

      <!-- Right: Actions -->
      <div class="actions" v-if="authUser.user === null">
        <button v-on:click="modalsSetShow('Login')" class="btn btn-secondary">
          Sign Up
        </button>
        <button v-on:click="modalsSetShow('Login')" class="btn btn-primary">
          Log In
        </button>
      </div>
      <UserSection v-else />
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserIcon from "@/components/icons/UserIcon";
import NotificationIcon from "@/components/icons/NotificationIcon";
import DepositDotIcon from "@/components/icons/DepositDotIcon.vue";
import UserSection from "./UserSection.vue";

export default {
  name: "Navbar",
  components: {
    UserIcon,
    NotificationIcon,
    DepositDotIcon,
    UserSection,
  },

  methods: {
    ...mapActions(["modalsSetShow"]),
  },
  computed: {
    ...mapGetters(["authUser"]),
  },
};
</script>

<style scoped>
.navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0.75rem 1.5rem;
  background-color: rgb(24 24 27 / 87%);
  backdrop-filter: blur(20px);
  z-index: 20;
}

.navbar-container {
  max-width: 75rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* --- Search --- */
.search-box {
  display: flex;
  align-items: center;
  background: rgb(36, 36, 40);
  padding: 0.75rem 1.123rem;
  border-radius: 9999px;
  color: #aaa;
  cursor: pointer;
  min-width: 17rem;
}

.logo {
  height: 50px;
  display: block;
}

.search-box .icon {
  width: 16px;
  height: 16px;
  margin-right: 0.5rem;
}

.search-input {
  background: transparent;
  border: none;
  outline: none;
  flex: 1;
  color: #ddd;
}

/* --- Right side --- */
.actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.lang {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2a2d32;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  position: relative;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 60px;

  left: 0;
  flex-direction: column;
  gap: 10px;
  background-color: rgb(36 36 40);
  border-radius: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: none;
}

.button-room {
  display: flex;
  gap: 5px;
  color: rgb(121 121 134);
  text-transform: uppercase;
  font-weight: 800;
  font-size: 1rem;
  padding: 0.5rem;
}

.dropdown-menu.dropdown-open {
  display: flex;
}

.button-room:hover {
  background-color: hsla(0, 0%, 100%, 0.06);
}

.rotate-icon {
  position: absolute;
  left: -8px;
  width: 16px;
  height: 16px;
}

.flag-img {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

/* --- Buttons --- */
.btn {
  padding: 0.75rem 1.25rem;
  border-radius: 9999px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.btn-secondary {
  background: rgb(255 255 255 / 5%);
  color: white;
}

.btn-primary {
  border-color: rgb(19 87 77);
  background-color: rgb(15 80 70);
  color: white;
}

.wallet-balance {
  display: flex;
  align-items: center;
  background: #1c1c1e; /* dark pill background */
  border-radius: 9999px;
  padding: 0.25rem 0.5rem;
  gap: 10px;
  border: 2px solid rgb(38 38 43);
  background-color: rgb(36 36 40);
}

.wallet-icon {
  background: #d6c68a; /* gold circle for $ */
  color: #000;
  font-weight: bold;
  border-radius: 50%;
  padding: 4px 8px;
  font-size: 14px;
}

.wallet-amount {
  font-weight: 600;
  color: #fff;
}

.deposit-btn {
  display: flex;
  align-items: center;
  font-weight: 600;
  border: none;
  border-radius: 9999px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  height: 2.5rem;
  cursor: pointer;
  transition: background 0.3s ease;
  border: 2px solid rgb(19 87 77);
  background-color: rgb(15 80 70);
  color: rgb(255 255 255);
}

.deposit-btn:hover {
  background: #047857; /* lighter green */
}

.deposit-icon {
  margin-right: 6px;
  font-size: 10px;
}

.icon-btn {
  border: 2px solid rgb(38 38 43);
  background-color: rgb(36 36 40);
  border-radius: 50%;
  border: none;
  width: 45px;
  height: 45px;
  color: #d6c68a;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile {
  border: 2px solid #d6c68a; /* gold border */
}

@media only screen and (max-width: 1024px) {
  .burger { display: inline-flex; }
}
@media only screen and (max-width: 640px) {
  .logo { height: 44px; }
}
@media only screen and (max-width: 400px) {
  .actions { gap: 0.5rem; }
  .btn { padding: 0.5rem 0.75rem; font-size: 0.875rem; }
}

/* Burger */
.burger {
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid rgb(38 38 43);
  background-color: rgb(36 36 40);
  margin-right: 10px;
  align-items: center;
  justify-content: center;
}
.burger .line {
  display: block;
  width: 18px;
  height: 2px;
  background: #fff;
  margin: 2px 0;
}
</style>
